import {
  APITagAttributes,
  ArdoqId,
  ScopeDataCollection,
} from '@ardoq/api-types';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const getTag = (
  scopeData: EnhancedScopeData,
  tagId: ArdoqId
): APITagAttributes | null => scopeData.tagsById[tagId] ?? null;

export const getAttributes = (
  scopeData: EnhancedScopeData,
  tagId: ArdoqId,
  attributes: (keyof APITagAttributes)[]
) => {
  const tag = scopeData.tagsById[tagId];
  return attributes.reduce(
    (acc, val) => {
      return { ...acc, [val]: tag ? tag[val] : '' };
    },
    { _id: '', name: '', rootWorkspace: '' }
  ) as Pick<APITagAttributes, keyof APITagAttributes>;
};

export const getIdsOfComponentsWithTag = (
  scopeData: EnhancedScopeData,
  tagId: ArdoqId
) => {
  return scopeData.tagsById[tagId]?.[ScopeDataCollection.COMPONENTS] ?? [];
};

export const getIdsOfReferencesWithTag = (
  scopeData: EnhancedScopeData,
  tagId: ArdoqId
) => {
  return scopeData.tagsById[tagId]?.[ScopeDataCollection.REFERENCES] ?? [];
};
